module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-entity', [_c('a-entity', {
    attrs: {
      "light": "type: ambient; color: #6B4BBA; intensity: 0.5;"
    }
  }), _vm._v(" "), _c('a-entity', {
    attrs: {
      "id": "spot-light",
      "light": "type: spot; angle: 45; color: #21C2CC; penumbra: 1; distance: 17; intensity: 0.7; decay: -3;",
      "position": _vm.attributify(_vm.position)
    }
  }, [_c('a-animation', {
    attrs: {
      "attribute": "light.intensity",
      "begin": "turn-the-light-off",
      "to": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c76895a2!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Light.vue
// module id = 185
// module chunks = 2